export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20interior%20with%20a%20large%20modern%20television%20screen%20displaying%20abstract%20colorful%20visuals%2C%20comfortable%20sofa%20with%20throw%20pillows%2C%20soft%20ambient%20lighting%20from%20warm%20floor%20lamps%2C%20wooden%20coffee%20table%20with%20popcorn%20bowl%2C%20cozy%20entertainment%20atmosphere%2C%20evening%20mood%2C%20high%20quality%20interior%20photography%2C%20warm%20terracotta%20and%20cream%20color%20palette&width=800&height=600&seq=about-2026&orientation=landscape"
                alt="香蕉影视 - 在家追剧的温馨体验"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) target.parentElement.style.display = 'none';
                }}
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">关于香蕉影视</h2>
            <div className="space-y-4 text-foreground-600 text-sm leading-relaxed">
              <p>
                香蕉影视成立于2020年，是国内领先的免费高清在线追剧平台。我们始终坚持以用户需求为核心，
                不断优化观影体验，致力于让每一位追剧爱好者都能享受到"打开即看、秒开不卡"的极致体验。
              </p>
              <p>
                平台已收录超过20000部热门电视剧资源，涵盖国产剧、韩剧、美剧、日剧、泰剧等全品类内容，
                每日同步更新最新剧集，确保用户第一时间看到想看的内容。所有剧集均支持1080P超清画质，
                无需注册登录即可畅享全部功能。
              </p>
              <p>
                我们的技术团队持续优化CDN加速与视频编解码能力，即使在网络条件一般的环境下，
                也能保证流畅播放不卡顿。截至目前，香蕉影视已累计服务超过5000万追剧用户，
                日均活跃用户突破300万，成为国内最受欢迎的免费追剧平台之一。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-user-heart-line text-primary-500 text-lg"></i>
                <span>5000万+ 忠实用户</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-tv-2-line text-accent-500 text-lg"></i>
                <span>覆盖全球 12 个地区</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-shield-check-line text-secondary-500 text-lg"></i>
                <span>安全无广告 纯净追剧</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}